import React from 'react'
import styled from 'styled-components'

const ButtonComponent = styled.button`
  width: ${props => (props.width ? props.width : 186)}px;
  height: ${props => (props.height ? props.height : 48)}px;
  background: ${props => (props.background ? props.background : '#333333')};
  border-radius: ${props => (props.radius ? props.radius : '4px')};
  border: ${props => (props.border ? props.border : 'none')};
  line-height: 1;
  letter-spacing: 1px;
  color: ${props => (props.color ? props.color : '#fff')};
  cursor: pointer;
  text-transform: ${props => (props.transform ? props.transform : 'uppercase')};
  font-family: Montserrat;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 1px;
  box-shadow: ${props => (props.shadow ? props.shadow : 'none')};
  -webkit-tap-highlight-color: transparent;
  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
  }
  &:focus {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
    outline: none;
  }
  @media (max-width: 768px) {
    height: 38px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 1.1px;
  }
`

export const Button = props => {
  return (
    <ButtonComponent
      color={props.color}
      height={props.height}
      width={props.width}
      background={props.background}
      border={props.border}
      radius={props.radius}
      {...props}>
      {props.title}
    </ButtonComponent>
  )
}



// WEBPACK FOOTER //
// ./src/components/Button.js